import { useSyncExternalStore } from "react";

export type Route = { view: "play"; coin: string } | { view: "floor" } | { view: "bankroll" };

export const DEFAULT_COIN = "BTC";

const coinOf = (text: string | undefined) => (text && /^[a-z0-9]{1,12}$/i.test(text) ? text.toUpperCase() : DEFAULT_COIN);

export function parse(pathname: string): Route {
  const [first, second] = pathname.split("/").filter(Boolean);
  switch (first) {
    case "bankroll":
    case "portfolio":
    case "house":
    case "staking":
      return { view: "bankroll" };
    case "floor":
    case "stats":
      return { view: "floor" };
    case "play":
    case "trade":
      return { view: "play", coin: coinOf(second) };
    default:
      return { view: "play", coin: DEFAULT_COIN };
  }
}

export function href(route: Route): string {
  return route.view === "play" ? `/play/${route.coin}` : `/${route.view}`;
}

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());
window.addEventListener("popstate", notify);

export function navigate(to: string, replace = false): void {
  if (to === window.location.pathname) return;
  if (replace) window.history.replaceState(null, "", to);
  else window.history.pushState(null, "", to);
  window.scrollTo({ top: 0 });
  notify();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePathname(): string {
  return useSyncExternalStore(subscribe, () => window.location.pathname);
}

export function useRoute(): Route {
  return parse(usePathname());
}
